// Core
import { FC } from 'react';

// Vendors
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';

interface TFormError {
  message?: string;
}

export const FormError: FC<TFormError> = ({ message }) => {
  if (!message) return null;

  return (
    <div className="bg-destructive/15 p-3 rounded-md flex items-center gap-x-2 text-sm text-red-600 dark:text-white">
      <ExclamationTriangleIcon className="w-4 h-4" />
      <p>{message}</p>
    </div>
  );
};
